/* eslint-disable no-shadow */
import Env from './utils/env';

export interface DubitLocation extends Location {
  state: {
    background: DubitLocation;
    isParentOfModal?: boolean,
  },
}

export const USE_MODAL_QUERY_PARAM = 'modal=true';

export const Routes = {
  Home: '/',
  NoIslands: '/no-islands',
  Islands: {
    Index: '/islands',
    View: '/islands/:id',
    New: '/islands/new',
    Games: {
      View: '/islands/:islandId/games/:gameId',
    },
  },
  Session: {
    New: '/login',
    NewCredentials: '/login?reset=true',
    Destroy: '/logout',
  },
  Account: {
    Index: '/account',
    User: {
      Edit: '/account/my-account',
    },
    Schools: {
      Index: '/account/schools',
    },
    School: {
      Edit: '/account/schools/:id',
    },
    Islands: {
      Index: '/account/islands',
    },
    Leaderboard: {
      Index: '/account/leaderboard',
    },
    Student: {
      Show: '/account/islands/:id',
      GameScore: '/account/islands/:id/:gameId',
      Delete: '/account/islands/:id/delete',
    },
  },
  Products: Env.SHOP_PRODUCTS_URL,
  Schools: Env.TEACHER_PORTAL_URL,
  Resources: Env.SHOP_RESOURCES_URL,
  Devotionals: Env.SHOP_DEVOTIONALS_URL,
  User: {
    New: '/register',
  },
  PasswordReset: '/forgot-password',
};

export const ModalRoutes = {
  Island: {
    RegistrationPrompt: '/islands/:id/require-registration',
    Edit: '/islands/:id/edit',
    ClaimReward: '/islands/:islandId/games/:gameId/show/claim-rewards',
    ManageIsland: '/islands/:id/manage',
    ManageIslands: '/islands/manage',
  },
};

export default {};
